"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgWalletFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2 6.626v12.89a2 2 0 002 2h14a2 2 0 002-2v-2.337a3.5 3.5 0 000-6.326V8.516a2 2 0 00-2-2H2.002a2.02 2.02 0 00-.002.11zm16.5 5.89h-2a1.5 1.5 0 000 3h2a1.5 1.5 0 000-3z' }),
    react_1.default.createElement("path", { d: 'M18 4a2 2 0 00-2.428-1.953l-12 2.625H18v-.671z' }))); };
exports.default = SvgWalletFilled;
//# sourceMappingURL=WalletFilled.js.map